module.exports = __webpack_public_path__ + "img/NH_SNB1.b2ce5c0c.svg";